/* eslint-disable react/jsx-no-undef */
import * as React from "react";
import { useApiService, useTl } from "../../../../hooks";
import { SectionLinkedActivitiesApi, SectionLinkedActivitiesDto, SectionLinkedActivitiesSearch } from "../../../../api";
import { IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import { ETLCodes } from "../../../../locales";
import { CustomDataTable } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { ERoutes } from "../../../../ERoutes";
import { Link } from "react-router-dom";

export interface ISectionLinkedActivitiesPageProps {
  sectionId: number;
}

export const SectionLinkedActivitiesPage: React.FunctionComponent<ISectionLinkedActivitiesPageProps> = ({
  sectionId,
}) => {
  const api = useApiService(SectionLinkedActivitiesApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Activities),
        fieldName: "activityName",
        render: (row: SectionLinkedActivitiesDto) => (
          <Link target="_blank" to={`${ERoutes.activity}/${row.activityId}/detail/view`}>
            {row.activityName}
          </Link>
        ),
      },
    ],
    [t]
  );

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
    sortKeys: { activityName: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: SectionLinkedActivitiesSearch) => {
      return api.baseSearch(
        SectionLinkedActivitiesSearch.fromJS({
          ...sObj,
          languageCode: currentLanguage.languageCode,
          sectionId: sectionId,
        })
      );
    },
    [api, currentLanguage.languageCode, sectionId]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return <CustomDataTable tableState={tableState} loading={loading} columns={columns} />;
};
